export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0015s_0000_Black-&-White-31.c5d58de1.png";